import { StyledSpinner } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledBottomAdornment = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-top: 0.6rem;
`;

export const StyledLoadingSpinner = styled(StyledSpinner)`
  margin-right: 0.5rem;
`;
